export { default } from './StatisticsTable';
